import PageShell, { PageHeader, Prose } from "@/components/PageShell";
import Seo from "@/components/Seo";

const DmcaPage = () => (
  <PageShell>
    <Seo title="DMCA — Nema TV" description="How to submit a DMCA notice or counter-notice to Nema TV." path="/dmca" />
    <PageHeader eyebrow="Legal" title="DMCA Notice & Takedown" subtitle="Copyright policy under the Digital Millennium Copyright Act." />
    <Prose>
      <p>
        Nema TV respects the intellectual property rights of others and expects our users
        to do the same. If you believe content available through Nema TV infringes your
        copyright, please submit a DMCA notice to our designated agent below.
      </p>

      <h2>How to file a notice</h2>
      <p>Include the following in your written notice:</p>
      <ol>
        <li>Identification of the copyrighted work claimed to be infringed.</li>
        <li>Identification of the material claimed to be infringing and its location.</li>
        <li>Your contact information (name, address, phone, email).</li>
        <li>A statement of good-faith belief that the use is not authorised.</li>
        <li>A statement, under penalty of perjury, that the information is accurate and you are the owner or authorised to act.</li>
        <li>Your physical or electronic signature.</li>
      </ol>

      <h2>Designated agent</h2>
      <p>
        DMCA Agent, Nema TV<br />
        Email: <a href="mailto:dmca@nematv.com">dmca@nematv.com</a>
      </p>

      <h2>Counter-notice</h2>
      <p>
        If content of yours was removed and you believe the removal was in error, you may
        submit a counter-notice to the same address containing the elements required by 17
        U.S.C. § 512(g)(3).
      </p>
    </Prose>
  </PageShell>
);

export default DmcaPage;
